export const _ADD               = "f4efgSJ3Z3BR0RZ5gvDAsQ==";
export const _EDIT              = "BZWFoqtOz+eZnUBJEMrTiw==";
export const _VIEW              = "dnPNqI64SZijEIonM93SiA==";
export const _DELETE            = "c9mg9mLXrbsmAlBndYY4kw==";
export const _RECOVER           = "gnu/PsCCp0ml/yukQJmt1XE/CRHkL1yFw/AKYaEsTvE=";
export const _LIST              = "jwaMLwTashess85vRiV0Aw==";
export const _TRASH             = "3//UrY+zsPJqBOed09xBXw==";